import React from 'react';
import { renderItem } from './render';
import { FormItem } from './type';
import "./index.css";

type Props = {
  children?: any;
} & FormItem;

const ComponentFormItem = (props: Props) => {
  const { children, ...rest } = props;
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {props.children}
      {rest.formTitle && (
        <div className='component-title'>{rest.formTitle}</div>
      )}
      {renderItem(rest)}
    </div>
  )
}

export default ComponentFormItem;